import { render } from "./SongList.vue?vue&type=template&id=810f9476"
import script from "./SongList.vue?vue&type=script&lang=js"
export * from "./SongList.vue?vue&type=script&lang=js"

import "./SongList.vue?vue&type=style&index=0&id=810f9476&lang=css"
script.render = render

export default script